/**
 * Module-scope invalidators for the template list caches (S2, ARCFE-1018).
 *
 * These run outside a hook, so they need the app's queryClient singleton —
 * which is exactly what `configureTemplatesData` injects. A package cannot own
 * that singleton, and importing the app's would be the coupling this seam
 * exists to remove.
 */
import {
  GET_CONSULT_NOTE_TEMPLATES,
  GET_DOCUMENT_TEMPLATES,
  GET_PINNED_TEMPLATES,
  GET_TEMPLATE_CREATION_RECORD_BY_ID,
  GET_TEMPLATES,
} from '../contracts';
import { getTemplatesDataConfig } from './config';

export const invalidateAllTemplatesQuery = async () => {
  const { queryClient } = getTemplatesDataConfig();
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: [GET_TEMPLATES] }),
    queryClient.invalidateQueries({ queryKey: [GET_DOCUMENT_TEMPLATES] }),
    queryClient.invalidateQueries({ queryKey: [GET_CONSULT_NOTE_TEMPLATES] }),
    queryClient.invalidateQueries({ queryKey: [GET_PINNED_TEMPLATES] }),
  ]);
};

export const invalidateTemplateCreationRecordById = async (
  templateCreationRecordId: string
) => {
  const { queryClient } = getTemplatesDataConfig();
  return await queryClient.invalidateQueries({
    queryKey: [GET_TEMPLATE_CREATION_RECORD_BY_ID, { templateCreationRecordId }],
  });
};
